import { faBrowser } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@repo/videa-components/src/index';
import classNames from 'classnames';
import { useAtom } from 'jotai';

import { usePreferences } from '@/react-query/usePreferences';
import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

import { showImageQualityFindingsAtom } from '../multiFileViewer/imageToolbar/atoms';

import { ToolbarButton } from './ToolbarButton';

export const ImageQualityFindingsToggle = () => {
  const { t } = useLingui();
  const { trackEvent } = useTrackEvent();
  const { data: prefs } = usePreferences();
  const [showImageQualityFindings, setShowImageQualityFindings] = useAtom(
    showImageQualityFindingsAtom,
  );

  // Only show this toggle if the preference is enabled
  const isImageQualityInsightsEnabled =
    prefs?.imageQualityInsightsInImageViewer ?? false;

  if (!isImageQualityInsightsEnabled) {
    return null;
  }

  const handleToggle = () => {
    const newValue = !showImageQualityFindings;
    setShowImageQualityFindings(newValue);
    trackEvent(mixpanelEvents.imageQualityFindingsToggle, {
      showImageQualityFindings: newValue,
    });
  };

  return (
    <div className="vai-flex vai-flex-col vai-gap-1 vai-bg-zinc-700 vai-rounded-sm vai-p-1">
      <Tooltip>
        <TooltipTrigger asChild>
          <ToolbarButton
            dataTestId="image-quality-findings-toggle"
            isActive={showImageQualityFindings}
            onClick={handleToggle}
          >
            <div className="vai-relative">
              <FontAwesomeIcon
                icon={faBrowser}
                className={classNames(
                  'max-[880px]:!vai-w-4 max-[880px]:!vai-h-4 min-[880px]:!vai-w-5 min-[880px]:!vai-h-5',
                  {
                    'vai-text-sapphire-500': showImageQualityFindings,
                    'vai-text-slate-300': !showImageQualityFindings,
                  },
                )}
              />
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                className="vai-absolute !vai-w-2.5 !vai-h-2.5 vai-text-amber-400 vai-top-0 vai-right-0 vai-translate-x-1 vai--translate-y-0.5"
              />
            </div>
          </ToolbarButton>
        </TooltipTrigger>
        <TooltipContent
          variant="dark"
          side="right"
          sideOffset={8}
          alignOffset={-4}
        >
          {showImageQualityFindings
            ? t`Hide Image Quality Findings`
            : t`Show Image Quality Findings`}
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
